import api, { UPLOADS_URL } from './api';

const uploadService = {
  /**
   * Subir logo de la empresa
   */
  async uploadLogo(file) {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await api.post('/upload/logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al subir logo'
      };
    }
  },

  /**
   * Eliminar imagen
   */
  async deleteImage(filename) {
    try {
      const response = await api.delete(`/upload/${filename}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar imagen'
      };
    }
  },

  /**
   * Obtener URL completa de la imagen
   */
  getImageUrl(imagePath) {
    if (!imagePath) return null;
    const normalizedUrl = this.normalizeExternalImageUrl(imagePath);
    if (normalizedUrl.startsWith('http')) return normalizedUrl;
    if (normalizedUrl.startsWith('/') && !normalizedUrl.startsWith('/uploads/')) {
      return normalizedUrl;
    }
    
    // Si la ruta empieza con /uploads/, quitarlo
    const cleanPath = imagePath.replace(/^\/uploads\//, '');
    
    return `${UPLOADS_URL}/${cleanPath}`;
  },

  /**
   * Convierte enlaces compartidos de Drive en enlaces aptos para <img>.
   */
  normalizeExternalImageUrl(imagePath) {
    const value = String(imagePath || '').trim();
    if (!value) return '';

    try {
      const url = new URL(value);
      if (url.hostname === 'drive.google.com') {
        const fileMatch = url.pathname.match(/\/file\/d\/([^/]+)/);
        const fileId = fileMatch?.[1] || url.searchParams.get('id');
        if (fileId) {
          return `https://drive.google.com/thumbnail?id=${encodeURIComponent(fileId)}&sz=w1200`;
        }
      }
    } catch (_) {
      // Las rutas locales antiguas se resuelven en getImageUrl.
    }

    return value;
  }
};

export default uploadService;


